import { Injectable } from '@angular/core';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { FeedbackMetaModel } from 'common/models/page-models/feedback/feedback-meta-model';
import { FeedbackFormDataService } from 'common/services/data-services/admin/feedback/feedback-form-data.service';


@Injectable({
  providedIn: 'root',
})
export class FeedbackFormWidgetService extends FormWidgetService<FeedbackModel> {
  constructor(protected ds: FeedbackFormDataService) {
    super(ds);
  }
  getMetaModel(): MetaModel {
    const meta = new FeedbackMetaModel();
    return meta.getMetaModel();
  }
   override prepareMetaModel(dataModel:FeedbackModel, metaModel: FeedbackMetaModel, routeData: WidgetModel): Promise<FeedbackMetaModel> {
    return new Promise<FeedbackMetaModel>((resolve, reject) => {
        metaModel.pageTitle = dataModel.id !== 0 ? "Edit Feedback" : "Add Feedback";
        
        resolve(metaModel);
      })
}
}
